import template from './sw-skeleton-bar.html.twig';
import './sw-skeleton-bar.scss';

const { Component } = Shopware;

/**
 * @private
 */
Component.register('sw-skeleton-bar', {
    template,
});
